'use client';

import LegacySuccessIconWithShadow from '@/app/_components/icons/legacy/LegacySuccessIconWithShadow';
import ModalButton from '@/app/(football)/[team]/_components/common/ModalButton';
import { useAppDispatch } from '@/store/client/config';
import { modalActions } from '@/store/client/slices/modalSlice';
import { useGetMyPointQuery } from '@/store/server/common/point/point.query';

interface EarnSuccessModalProps {
  point: number;
}

export default function EarnSuccessModal({ point }: EarnSuccessModalProps) {
  const dispatch = useAppDispatch();
  const { data: myPoint } = useGetMyPointQuery();
  const formattedPoint = myPoint?.point.toLocaleString('ko-KR') ?? '-';

  const handleCloseModal = () => {
    dispatch(modalActions.closeModal());
  };

  return (
    <div className="flex w-[320px] flex-col items-center rounded-lg bg-g-00 px-5 py-6">
      {/* 아이콘 */}
      <div className="mb-5 flex items-center justify-center">
        <LegacySuccessIconWithShadow
          size={56}
          foreground="var(--color-modal-icon)"
          background="#E8E8E8"
          gradient={{ from: '#E9E9E9', to: '#DADADA' }}
        />
      </div>

      {/* 타이틀 */}
      <div className="flex w-full flex-col items-center gap-2">
        <p className="typo-body-1 text-center text-g-90">미션 포인트 수령 완료!</p>
        <p className="typo-body-5 text-center text-g-60">(+{point} Point 획득)</p>
      </div>

      {/* 보유 포인트 */}
      <div className="mt-5 flex w-full items-center justify-between rounded border border-g-30 px-4 py-3">
        <span className="typo-body-5 text-g-60">보유 포인트</span>
        <span className="typo-body-4 text-g-90">{formattedPoint}P</span>
      </div>

      {/* 버튼 영역 */}
      <div className="mt-6 flex w-full items-center gap-2">
        <ModalButton
          variant="primary"
          onClick={handleCloseModal}
        >
          확인
        </ModalButton>
      </div>
    </div>
  );
}
